export default "__VITE_ASSET__CJBiJJt___"